import Navbar from "../../components/Navbar/Navbar";
import Footer from '../../components/Footer/Footer';
import Initiatives from '../../components/Initiatives/Initiatives';
import BackToTop from '../../components/BackToTop/BackToTop';
import PageHeader from "../../components/PageHeader/PageHeader";
import maizeImg from '../../assets/images/programs/training/maize.png';

export default function Events() {
    return (
        <>
            <Navbar />
            <PageHeader title="Flagship Events" path="/event" name="Events" backgroundImage={maizeImg} />
            <Initiatives />
            <Footer />
            <BackToTop />
        </>
    );
}